<template>
    <div class="ngdialog-content">
        <dialog-header>
            <h4>{{ $t('systems.invite_new_partner') }}</h4>
        </dialog-header>

        <form name="inviteForm" novalidate @submit.prevent="submit()" class="form">
            <div class="ngdialog__body">
                <p v-if="$can('invite partner', system)">{{ $t('systems.invite_technician_note') }}</p>

                <div v-if="loadingData" class="ngdialog__loader svg-content__inner__loader">
                    {{ $t('general.entries_being_loaded') }}
                    &nbsp;
                    <i class="icon icon--common-spinner spinner"></i>
                </div>

                <fieldset class="form__group">
                    <label class="form__label">
                        <select name="organization_id" v-model="$v.formData.organization_id.$model" class="form__field form__field--select" autofocus :disabled="loadingData">
                            <option v-for="o in availableOrganizations" :value="o.id" :key="o.id">{{ o.name }}</option>
                        </select>
                    </label>
                </fieldset>
            </div>

            <dialog-buttons :submit-text="$t('buttons.save')" :disabled="loading" />
        </form>
    </div>
</template>

<script>
import * as api from '@/api';
import { mapState } from 'vuex';
import DialogHeader from '@/components/DialogHeader';
import DialogButtons from '@/components/DialogButtons';
import autofocus from '@/directives/autofocus';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'system-partner-invitation',
    components: {
        DialogHeader,
        DialogButtons,
    },
    directives: {
        autofocus,
    },
    props: {
        system: {
            type: Object,
            required: true,
        },
        successCallback: {
            type: Function,
        },
    },
    data() {
        let data = {
            formData: {
                organization_id: null,
            },
            loadingData: true,
            loading: false,
            availableOrganizations: false,
        };

        return data;
    },
    computed: {
        ...mapState(['activeSystem', 'userData']),
    },
    validations() {
        return {
            formData: {
                organization_id: { required },
            },
        };
    },
    created() {
        this.loadAvailableOrganizations();
    },
    methods: {
        submit() {
            if (this.$v.formData.$invalid) {
                this.$v.formData.$touch();
                return;
            }

            this.loading = true;

            this.inviteTechnican();
        },
        async loadAvailableOrganizations() {
            try {
                const response = await api.organizations.suborganizations(this.userData.organization.id, {
                    disable_pagination: true,
                    recursive: true,
                });
                this.loadingData = false;

                if (response) {
                    this.availableOrganizations = response.data.suborganizations;
                    this.availableOrganizations = this.availableOrganizations.sort((a, b) => a.name.localeCompare(b.name));
                }
            } catch (error) {
                console.error(error);
            }
        },
        async inviteTechnican() {
            try {
                const response = await api.systems.inviteTechnician(this.system.id, this.formData);
                if (response) {
                    if (this.successCallback) {
                        this.successCallback();
                    }

                    this.$emit('close');
                }
                this.loading = false;
            } catch (error) {
                console.error(error);
                this.$notify({
                    type: 'error',
                    text: this.$t('systems.management.errors.could_not_change_partner'),
                });
                this.loading = false;
            }
        },
    },
};
</script>
